(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["biomax-bf-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template') &&
        activeMedia.querySelector('template').content &&
        activeMedia.querySelector('template').content.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elvtd-biomax-bf-product"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template') &&
        activeMedia.querySelector('template').content &&
        activeMedia.querySelector('template').content.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new_faq_section"] && !Shopify.designMode) return;
  try {
    
  // https://cdn.shopify.com/s/files/1/0860/2710/8625/files/new-plus.svg?v=1743047453

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["road-map-timeline"]) return;
  try {
    
  $('.show-less-more-btn.mobile a.btn').click(function (e) {
    e.preventDefault();
    console.log(this);
    $('.timeline-desktop').toggleClass('max_width_100');
    if ($('.timeline-desktop').hasClass('max_width_100')) {
      $('.show-less-more-btn.mobile a.btn span.btn_text').text('SHOW LESS');
    } else {
      $('.show-less-more-btn.mobile a.btn span.btn_text').text('SHOW MORE');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
